module.exports = __webpack_public_path__ + "img/custom-title@2x.da82bac0.png";